import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {PrintMapComponent} from 'src/app/popup/print-map/print-map.component';
import {ExportControlService} from 'src/app/popup/services/export-control.service';
import {MapService} from 'src/app/services/map.service';
import {MenuManagementService} from '../services/menu-management.service';
import {GritUserRoleGroup, GritUserService} from "../../services/grit/grit.user.service";

@Component({
  selector: 'app-export-menu',
  templateUrl: './export-menu.component.html',
  styleUrls: ['./export-menu.component.scss'],
  standalone: false
})
export class ExportMenuComponent implements OnInit {

  navaidsOptions: string[] = ['Selected Navaids to XML', 'All Navaids to XML', 'Selected Navaids to CSV', 'All Navaids to CSV','All Navaids to Safire', 'Selected Navaids to Safire'];
  coordPointsOptions: string[] = ['Selected Coordinate Points to XML', 'All Coordinate Points to XML'];
  proceduresOptions: string[] = ['Selected Procedures to XML', 'All Procedures to XML'];
  airSpaceBoundariesOptions: string[] = ['Selected AirSpace Boundaries to XML', 'All AirSpace Boundaries to XML'];

  deviceOptions: string[] = ['All RFI-Transmitters to JSON']
  interferenceTestDeviceOptions: string[] = ['All RFI-Transmitters to JSON', 'Selected RFI-Transmitters to JSON']
  receiverOptions: string[] = ['All Receivers to JSON']

  constructor(public menuService: MenuManagementService,
              public exportService: ExportControlService,
              public modalService: BsModalService,
              public mapService: MapService,
              public  gritUserService: GritUserService,
  ) {

  }

  ngOnInit(): void {
  }

  exportMapToImage(): void {
    const bs: BsModalRef = this.modalService.show(PrintMapComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bs.content.type = "export"
  }

  printMap(): void {
    const bs: BsModalRef = this.modalService.show(PrintMapComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bs.content.type = "print"

  }

  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
